/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientInstructionsModel } from '../../models/patient-instructions-model';

export interface UpdateTargetInstructions$Params {
  targetID?: number;
      body?: PatientInstructionsModel
}

export function UpdateTargetInstructions(http: HttpClient, rootUrl: string, params?: UpdateTargetInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UpdateTargetInstructions.PATH, 'post');
  if (params) {
    rb.query('targetID', params.targetID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UpdateTargetInstructions.PATH = '/api/Supervisor/UpdateTargetInstructions';
